/* GENERATED from ai-designer/web/match.mjs by tools/build_designer_assets.py - edit the source, then rebuild. */
(function () {
// Library matching for the question flow. Pure functions (no DOM); tested with node --test.
const words = (text) => String(text || "").toLowerCase().match(/[a-z]{3,}/g) || [];

function colorScore(colorway, design, answers, palettes) {
  const chosen = answers.colors || [];
  if (!chosen.length) return colorway.palette === design.base_palette ? 10 : 0;
  const colors = (palettes[colorway.palette] || { colors: [] }).colors;
  const hits = chosen.filter((c) => colors.includes(c)).length;
  return hits === chosen.length ? 40 : hits ? 20 : 0;
}

function bestColorway(design, answers, palettes, exclude) {
  let best = null;
  for (const cw of design.colorways) {
    if (exclude.includes(cw.sku)) continue;
    const s = colorScore(cw, design, answers, palettes);
    if (!best || s > best.s || (s === best.s && cw.sku < best.cw.sku)) best = { cw, s };
  }
  return best;
}

function match(library, answers, { exclude = [], count = 4 } = {}) {
  if (!library || !Array.isArray(library.designs)) return [];
  const text = words(answers.text);
  const imagery = answers.imagery || [];
  const scored = [];
  for (const d of library.designs) {
    if (d.colorways.some((cw) => exclude.includes(cw.sku))) continue;
    const best = bestColorway(d, answers, library.palettes, exclude);
    if (!best) continue;
    let score = best.s;
    if (d.style === answers.style) score += 100;
    score += 8 * d.imagery.filter((t) => imagery.includes(t)).length;
    score += 6 * text.filter((w) => d.keywords.includes(w) || d.imagery.includes(w)).length;
    if (d.vibe === answers.who) score += 5;
    scored.push({ design: d, colorway: best.cw, score });
  }
  scored.sort((a, b) => b.score - a.score || (a.design.sku < b.design.sku ? -1 : 1));
  const picked = [];
  const layouts = new Set();
  while (picked.length < count && scored.length) {
    let bi = 0;
    let bs = -Infinity;
    scored.forEach((c, i) => {
      const s = c.score - (layouts.has(c.design.layout) ? 5 : 0);
      if (s > bs) { bs = s; bi = i; }
    });
    const [c] = scored.splice(bi, 1);
    picked.push({ design: c.design, colorway: c.colorway });
    layouts.add(c.design.layout);
  }
  return picked;
}

function moreLike(library, design, answers, { exclude = [], count = 4 } = {}) {
  const own = design.colorways
    .filter((cw) => !exclude.includes(cw.sku))
    .map((cw) => ({ cw, s: colorScore(cw, design, answers, library.palettes) }))
    .sort((a, b) => b.s - a.s || (a.cw.sku < b.cw.sku ? -1 : 1))
    .slice(0, count)
    .map(({ cw }) => ({ design, colorway: cw }));
  if (own.length >= count) return own;
  const similar = { ...answers, style: design.style, imagery: design.imagery };
  const skip = [...exclude, ...design.colorways.map((cw) => cw.sku)];
  return own.concat(match(library, similar, { exclude: skip, count: count - own.length }));
}
window.RPMatch = { colorScore: colorScore, match: match, moreLike: moreLike };
})();
